import type { FilterItem } from "@repo/models";

import { KeyedArray } from "@repo/models";
import { mapToKeyedArray } from "@repo/models/filterItem";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export { QUERY_KEYS } from "./queryKeys";
export { BRANDS, BRANCHES, CHANNELS, MARKETERS, STATES, GET_USER_INFO } from "./queryKeys";
export { COMPANIES, DIVISIONS, REGIONS, MARKETS } from "./queryKeys";

// Backward-compat constants are re-exported from queryKeys.ts
// BRANCHES, CHANNELS, BRANDS, MARKETERS, STATES

export function useFilterItemQuery<T extends FilterItem = FilterItem>(
	name: string[],
	api: (...params) => Promise<(T | FilterItem)[]>,
	...params
) {
	const query = useQuery({ queryKey: [...name, ...params], queryFn: callApi });
	const data = useMemo(() => query.data ?? emptyArray, [query.data]);
	const loaded = query.isFetched;

	return [data, loaded] as [KeyedArray<T>, boolean];

	async function callApi() {
		return await api(...params).then(mapToKeyedArray);
	}
}

const emptyArray = new KeyedArray<FilterItem>([], (k) => k.id);
